import styled from 'styled-components';

const ContainerWrapper = styled.div<{isMobile: boolean}>`
  width: 100%;
  max-width: 1460px;
  margin: 0 auto;
  padding: ${(p) => (p.isMobile ? '30px 0' : '100px 0')};
  min-height: 65vh;
`;

const Title = styled.div<{ isMobile: boolean, isTablet: boolean }>`
  font-family: 'Roboto', sans-serif;
  font-size: ${(p) => p.theme.fontSizes.md};
  font-weight: 700;
  color: ${(p) => p.theme.colors.gray500};
  margin-bottom: ${(p) => (p.isTablet ? '20px' : '40px')}};
  text-align: center;
`;

const LogoPic = styled.img<{ height: number }>`
  height: ${(p) => p.height}px;
object-fit: contain;
  object-position: center;
`;

const SwiperBtn = styled.button`
  position: absolute;
  display: flex;
  cursor: pointer;
  top: 50%;
  transform: translateY(-50%);

  &.logoNextBtn {
    right: 0;
    z-index: 10;

    > img {
      width: 40px;
    }
  }

  &.logoPrevBtn {
    left: 0;
    z-index: 10;

    > img {
      width: 40px;
    }
  }

  > img {
    margin: auto;
  }
`;

export { ContainerWrapper, Title, LogoPic, SwiperBtn };
